import { TableCell } from '@material-ui/core';
import StatusIcon from 'components/StatusIcon';
import _ from 'lodash';
import * as React from 'react';
import { Shift } from 'services/helpers/shift';
import { ErlContext } from 'pages/T_Appointments/context';
import WithLegendPopover from '../../../WithLegendPopover';
import { HatchedCell } from '../HatchedCell';
import { clockStatus, MESSAGES, SHIFTS_REF } from '../../constants/next-appointments.constants';
import { NextAppointmentsService } from '../../services/next-appointments.service';
import { GateClosedCell } from './GateClosed';

interface Props {
  shift: Shift;
  terminalKey: string;
  instructions: { status: string; warnings: string[] };
  classes: Record<string, string>;
  currentContainerKey: string;
}

export const CheckAppointmentsPortalCell: React.FC<Props> = (props) => {
  const { shift, terminalKey, instructions, classes, currentContainerKey } = props;
  const { status, warnings } = instructions || {};
  const erlData = React.useContext(ErlContext);

  let message = MESSAGES.noData;

  if (shift && terminalKey) {
    const gateData = NextAppointmentsService.getGateData(erlData.gateHours, terminalKey, shift);
    if (NextAppointmentsService.checkIsGateClosed(gateData)) {
      message = MESSAGES.gateClosed;
    }
  }

  const className =
    shift.shift === SHIFTS_REF.shift2
      ? classes.checkAppointmentsPortalFatGrey
      : classes.checkAppointmentsPortalGrey;

  if (message && message === MESSAGES.gateClosed) {
    return <GateClosedCell message={message} shift={shift} classes={classes} />;
  }

  return (
    <TableCell className={className} align="center">
      <WithLegendPopover
        isShown
        status={status || clockStatus}
        warnings={warnings}
        formattedTimeSlot={_.capitalize(message)}
      >
        <HatchedCell />
        <div>{message}</div>
        {currentContainerKey && (
          <StatusIcon
            status={status || clockStatus}
            warnings={warnings}
            isGrey
            isEmptyAppointments
          />
        )}
      </WithLegendPopover>
    </TableCell>
  );
};
CheckAppointmentsPortalCell.displayName = 'AppointmentsTable.CheckAppointmentsPortalCell';
